

  <div class="row text-center d-flex justify-content-center">

    <div class="col-sm-12 col-md-3 col-lg-3 mb-3"
         *ngFor="let product of products?.products">
      <a class="swing-entrances-link" [routerLink]="['/build-and-buy/product-config',product.id]">
        <div class="imagebox">
          <span class="imagebox-desc">{{product.name}}</span>
          <!--<img src="{{product.productImageUrl}}"
               alt="{{product.productImageUrl}}"
               style="width:250px">-->
          <img src="{{product.productImageUrl}}"               
               style="width:250px">
        </div>
        <div class="productDescription"
             style="border: 1px solid lightgray; border-radius: 2px;margin-top: 23px">
          <ul class="buildBuyDescription">
            <li *ngFor="let p of product.description.split('abcdTest')">{{p}}</li>
          </ul>
        </div>
      </a><!--end of a tag-->
    </div><!--end of col div-->
  
   
  </div>
  
